<template>
	<v-app-bar app color="appTheme" :elevation="0" dense dark>
		<v-app-bar-nav-icon :height="40" :width="40" class="ml-n1 mr-n3"  @click.stop="handlerSidebar"></v-app-bar-nav-icon>
		<v-toolbar-title class="">{{ $route.name }}</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-btn icon :height="40" :width="40" class="mr-1" href="https://invoice-audit-guide.netlify.app" target="_blank" v-tooltip.bottom="'Guide'">
			<v-icon>mdi-help-circle</v-icon>
		</v-btn>
		<v-divider inset vertical></v-divider>
		<v-menu offset-y left>
			<template v-slot:activator="{ on }">
				<v-btn text :height="40" id="userBtn"  class="mr-n1" v-on="on">
					<Avatar class="mr-1" :size="35" :username="user"/>
					<span>{{ user }}</span>
				</v-btn>
			</template>

			<v-list dense class="mt-n2" color="appTheme">
				<v-list-item to="/user-profile">
					<v-icon left small class="ml-1">mdi-account-check</v-icon>
					<v-list-item-title>
						Profile
					</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item @click="logout" class="mb-n2">
					<v-icon left small class="ml-1">mdi-logout-variant</v-icon>
					<v-list-item-title>Sign-out</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
// import Breadcrumb from './Breadcrumb';
import Avatar from 'vue-avatar'
export default {
	props: {
		handlerSidebar: {
			type: Function,
			required: true
		}
	 },
	components: {
		Avatar
	},
	data: () => ({
		tabMenu: '#menu1'
	}),
	methods: {
		logout() {
			this.$Progress.start();
			setTimeout(() => {
				localStorage.removeItem('user');
				localStorage.removeItem('token');
				this.$router.push('/signin');
				this.$Progress.finish();
			},500)
		}
	},
	computed: {
		page: function() {
			return this.$route.meta.title;
		},
		title: function () {
			return this.$route.name
		},
		user: function(){
			let userData = JSON.parse(localStorage.getItem('user'));
			return userData.user_name
		}
	}
};
</script>

<style scoped>
*{
	color: #fff !important;
}
.v-toolbar__title{
	font-size: 16px !important;
	font-weight: 600;
}
#userBtn{
	text-transform: none !important;
}
hr.v-divider{
	margin-left: 13px !important;
	margin-right: 12px !important;
}
</style>